<template>
  <div :bordered="false" style="overflow: auto !important" class="maskContent">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('platformCollection.name_of_collector')">
              <a-input
                :placeholder="$t('enter') + ' ' + $t('platformCollection.name_of_collector')"
                v-model="queryParam.userName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('Collector account')">
              <a-input :placeholder="$t('enter') + $t('Collector account')" v-model="queryParam.sysmobile"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="10" :sm="10">
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'createTime')">
              <a-range-picker v-model="queryParam.endTime" format="DD-MM-YYYY" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="10" :sm="10">
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'settleTime')">
              <a-range-picker v-model="queryParam.settleTime" format="DD-MM-YYYY" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'overdueDaysStart')">
              <a-input
                :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY.ORDER + 'overdueDays'))"
                v-model="queryParam.overdueDaysStart"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('platformCollection.department')">
              <a-select v-model="queryParam.departmentId" @change="onChangeOne">
                <a-select-option v-for="item in departmentList" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('platformCollection.grouping')">
              <a-select v-model="queryParam.groupId">
                <a-select-option v-for="item in groupList" :key="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('platformCollection.collection_stage')">
              <a-select default-value="" style="width: 190px" v-model="queryParam.normalConfigId">
                <a-select-option v-for="item in normalConfigList" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('platformCollection.orderType')">
              <a-select
                default-value="0"
                style="width: 190px"
                v-model="queryParam.orderType"
                :options="[
                  { value: '', label: $t('platformCollection.all_orders') },
                  { value: '2', label: $t('platformCollection.normal_order_early_collection') },
                  { value: '0', label: $t('platformCollection.normal_order') },
                  { value: '-1', label: $t('platformCollection.early_collection_order') },
                  { value: '1', label: $t('platformCollection.recovered_order') },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('User Type')">
              <a-select default-value="" style="width: 120px" v-model="queryParam.loanCountFlag">
                <a-select-option value="">
                  {{ $t('platformCollection.all_customers') }}
                </a-select-option>
                <a-select-option value="00">
                  {{ $t('platformCollection.new_customer') }}
                </a-select-option>
                <a-select-option value="01">
                  {{ $t('platformCollection.old_customer') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('order.applicationDeadline')">
              <a-select mode="multiple" default-value="" style="width: 190px" v-model="queryParam.durations">
                <a-select-option v-for="item in deadlineConfigList" :key="item.itemValue">
                  {{ item.itemText }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('platformCollection.stageType')">
              <dict-select
                v-model="queryParam.collectorType"
                :dict-code="DICT_CODE.STAGE_TYPE"
                :begin="[{ value: '', label: $t('platformCollection.all_customers'), labelEn: 'All' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('Installment as aggregation condition')">
              <dict-select
                v-model="queryParam.collectorFlag"
                :dict-code="DICT_CODE.NO"
                :begin="[{ value: '', label: $t('platformCollection.all_customers'), labelEn: 'All' }]"
                :placeholder="$t('select')"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('reset')
              }}</a-button>
              <!--              <a-button type="primary" @click="downLoadData" icon="download" style="margin-left: 8px">{{-->
              <!--                $t('exportFile') }}</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :rowClassName="
          (record) =>
            isWeekDay(record.createdDate)
              ? 'table_weekendColor'
              : record.createdDate == this.$t('platformCollection.subtotal')
              ? 'subtotal'
              : isbetweenWeek(record.createdDate)
              ? 'betweenWeek'
              : ''
        "
        bordered
      >
        <span slot="action" slot-scope="text, record">
          <a-button @click="nuodan(record)">{{ $t('Remove his order') }}</a-button>
        </span>
      </a-table>
    </div>
    <a-modal v-model="visiblenuo" :title="$t('Remove his order')" on-ok="handleOk" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          {{ $t('cancel') }}
        </a-button>
        <a-button key="submit" type="primary" :loading="loadingnuo" @click="handleOk">
          {{ $t('confirm') }}
        </a-button>
      </template>
      <div style="height: 400px">
        <div class="modalItem">
          <div class="label">{{ $t('Unfinished') }}:</div>
          <a-input v-model="taskCount"></a-input>
        </div>
        <div class="modalItem">
          <div class="label">{{ $t('Dispatch order to') }}:</div>
          <a-select
            :placeholder="$t('Collector account')"
            v-model="checkUser"
            mode="multiple"
            style="width: 100%"
            :filter-option="filterOption"
          >
            <a-select-option v-for="(item, index) in colUserList" :key="index" :value="item.id">
              {{ item.mobile }}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </a-modal>
    <v-modal v-model="visible" :title="$t('order.collectionDetail')">
      <div style="padding: 20px">
        <collection-detail
          v-if="visible"
          :orderId="orderId"
          :custInfoId="custInfoId"
          :taskId="taskId"
          :auditDrawer="false"
          @close="visible = false"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  getCollectionPerformance,
  getSysGroup,
  appointDistributionTaskByUser,
  getColUserList,
  getCollectionPerformanceDays,
} from '@/webpublicapi/platformCollection'
import { getCollectionListDepartment } from '@/webpublicapi/group'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import CollectionDetail from './CollectionDetail'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'
import exportFile from '@/webpublicapi/exportFile'
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
}

export default {
  name: 'AllApprovalTask',
  components: {
    Dict,
    DictSelect,
    vModal,
    CollectionDetail,
  },
  data() {
    return {
      userId: '',
      checkUser: [],
      colUserList: [],
      taskCount: 0,
      loadingnuo: false,
      visiblenuo: false,
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      dataSource: [],
      groupList: [],
      departmentList: [],
      normalConfigList: [],
      deadlineConfigList: [],
      taskCount: 0,
      // Query conditions
      queryParam: {
        endTime: [moment(), moment()],
        orderNo: '',
        aadhaarName: '',
        mobileNo: '',
        groupId: '',
        sysmobile: '',
        durations: undefined,
        collectorType: undefined,
        collectorFlag: undefined,
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 },
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('platformCollection.date'),
          align: 'left',
          dataIndex: 'createdDate',
        },
        {
          title: this.$t('collection.collectionNumber'),
          align: 'left',
          dataIndex: 'collectionNum',
        },
        {
          title: this.$t('collection.collectionAmount'),
          align: 'left',
          dataIndex: 'applyAmt',
        },
        {
          title: this.$t('collection.succedNumber'),
          align: 'left',
          dataIndex: 'succedNum',
        },
        {
          title: this.$t('collection.extendNumber'),
          align: 'left',
          dataIndex: 'extendNum',
        },
        {
          title: this.$t('collection.succedAmount'),
          align: 'left',
          dataIndex: 'succedApplyAmt',
        },
        {
          title: this.$t('collection.amountPaidAmt'),
          align: 'left',
          dataIndex: 'amountPaidAmt',
        },
        {
          title: this.$t('collection.succedRate'),
          align: 'left',
          dataIndex: 'succedRate',
        },
        {
          title: this.$t('collection.amountSuccedRate'),
          align: 'left',
          dataIndex: 'amountSuccedRate',
        },
      ]
    },
  },
  created() {
    this.getDict()
    // this.loadData();
    getSysGroup().then((res) => {
      this.groupList = res.data || []
    })
    getCollectionListDepartment().then((res) => {
      this.departmentList = res.data || []
    })
    getAllNormalConfig().then((res) => {
      this.normalConfigList.push({
        name: this.$t('platformCollection.all_customers'),
        id: '',
        value: '',
      })
      res.data.forEach((item) => {
        this.normalConfigList.push(item)
      })
    })
    getAllDeadlineConfig().then((res) => {
      this.deadlineConfigList = res.data || []
    })
    this.getColUserListMeth()
  },
  methods: {
    isbetweenWeek(dateString) {
      if (dateString.length == 21) {
        console.log(2222222, dateString.length)
        return true
      }
    },
    isWeekDay(day) {
      const date = new Date(day)
      return date.getDay() % 6 === 0 ? true : false
    },
    showModal() {
      this.visiblenuo = true
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleOk(e) {
      this.loadingnuo = true
      appointDistributionTaskByUser({ userId: this.userId, ugIds: this.checkUser, taskCount: this.taskCount }).then(
        (res) => {
          if (res.code === 1000) {
            this.$message.success(this.$t('platformCollection.success_message'))
            this.visiblenuo = false
            this.checkUser = []
            this.loadData()
          } else {
            this.searchQuery()
            this.$message.error(res.msg)
          }
          this.loadingnuo = false
        }
      )
    },
    handleCancel(e) {
      this.visiblenuo = false
      this.checkUser = []
    },
    getColUserListMeth() {
      this.loading = true
      let reData = {
        pageNum: 1,
        pageSize: 10000,
        userstatus: 1,
      }
      getColUserList(reData).then((res) => {
        if (res.code === 1000) {
          this.colUserList = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    nuodan(record) {
      this.userId = record.userId
      this.taskCount = record.pendingNum + record.processNum
      this.visiblenuo = true
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData()
    },
    loadData(arg) {
      this.loading = true
      var params = this.getQueryParams() // Query conditions
      getCollectionPerformanceDays(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.dataSource = res.data || []
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { endTime } = this.queryParam
      const { settleTime } = this.queryParam
      const data = {
        ...this.queryParam,
        endDateStart: endTime && endTime.length ? this.transformTime(endTime[0]) : undefined,
        endDateEnd: endTime && endTime.length ? this.transformTime(endTime[1]) : undefined,
        settleDateStart: settleTime && settleTime.length ? this.transformTime(settleTime[0]) : undefined,
        settleDateEnd: settleTime && settleTime.length ? this.transformTime(settleTime[1]) : undefined,
      }
      delete data.settleTime
      delete data.endTime
      var param = Object.assign({}, data)
      // param.pageNum = this.form.pageNum;
      // param.pageSize = this.form.pageSize;
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.endTime = undefined
      that.queryParam.settleTime = undefined
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    onChangeOne(value) {
      console.log(value)
      getSysGroup({ departmentId: value }).then((res) => {
        this.groupList = res.data || []
        this.queryParam.groupId = ''
      })
    },
    downLoadData() {
      var params = this.getQueryParams() // Query conditions
      this.exportParams = Object.entries(params).map(([key, value]) => key + '=' + value) + ''
      const file = {
        fileUrl:
          '/api/web/webpublic/platform/collectionTask/performanceExcel?' + this.exportParams.replaceAll(',', '&'),
        fileName: 'report.xls',
      }
      // console.log(file.fileUrl)

      this.loading = true
      exportFile(file)
        .catch((e) => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';

.modalItem {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.label {
  width: 100px;
  text-align: center;
}
::v-deep.ant-modal-mask {
  position: absolute;
}
</style>
